import React from 'react';
import ReactDOM from 'react-dom';

import IntegratorsHandler from 'src/apps/integrators_handler'; 
import EmptySearch from 'src/apps/components/EmptySearch';

window.addEventListener('DOMContentLoaded', function () {
  IntegratorsHandler.renderTagsAndDrawer();

  const emptySearchContainer = document.getElementById('empty-search')
  if (emptySearchContainer) {
    const categories = emptySearchContainer.dataset.categories
    ReactDOM.render(<EmptySearch categories={ categories } />, emptySearchContainer);
  }
});
